var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.17,
    height: 15.747,
    viewBox: "0 0 11.17 11.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_hashtag_1780092",
    transform: "translate(-30.9 -29.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14334",
    "data-name": "Group 14334",
    transform: "translate(31 30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11224",
    "data-name": "Path 11224",
    d: "M34.951,982.362l-.83,3.175H31.577v.577h2.391l-1.055,4.042H31v.577h1.759l-.83,3.175h.6l.83-3.175h4.592l-.83,3.175h.6l.83-3.175h2.833v-.577H38.7l1.064-4.042h2.2v-.577H39.913l.839-3.175h-.6l-.83,3.175h-4.6l.839-3.175h-.6Zm-.379,3.753h4.592l-1.055,4.042h-4.6Z",
    transform: "translate(-31 -982.362)",
    fill: "var(--mainColor)",
    stroke: "var(--mainColor)",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashIcon);
export default __webpack_public_path__ + "static/media/hash-icon.eaba92c22bc161198b9b001d75162d79.svg";
export { ForwardRef as ReactComponent };